module.exports = __webpack_public_path__ + "img/group.7366ed0c.svg";